import {ChangeDetectionStrategy, Component, EventEmitter, OnInit} from '@angular/core';
import {NbAlertModule, NbButtonModule, NbCardModule, NbSpinnerModule, NbWindowRef} from '@nebular/theme';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ApiResponse, BaseComponent, CartProduct, SpecificationService} from 'compob2b-libs';
import {FileUploader, FileUploadModule} from 'ng2-file-upload';
import {takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../../../environments/translations.ru';
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-specification-file',
    templateUrl: './popup-file.component.html',
    styleUrls: ['./popup-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, FileUploadModule, NbCardModule, NbButtonModule, NbSpinnerModule, NbAlertModule, NgIf]
})

export class SpecificationPopupFileComponent extends BaseComponent implements OnInit {
  submitted = false;
  showFail = false;
  fileName: string = translations.chooseTheFile;
  fileSize = 0;
  fileType = '';

  maxFileSize = 0;
  allowedMimeTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'text/plain',
    'text/csv'
  ];

  onFoundProducts: EventEmitter<CartProduct[]>;
  fileTypeError: boolean;

  uploader: FileUploader;
  file: File;

  inputForm = new UntypedFormGroup({
    file: new UntypedFormControl(null, Validators.required)
  });

  constructor(private readonly windowRef: NbWindowRef,
              private readonly specificationService: SpecificationService) {
    super();
  }

  ngOnInit(): void {

    this.uploader = new FileUploader({
      url: null,
      disableMultipart: false,
      formatDataFunctionIsAsync: false,
      isHTML5: true,
      removeAfterUpload: false,
      autoUpload: false,
      maxFileSize: 25 * 1024 * 1024,
      allowedMimeType: this.allowedMimeTypes
    });

    this.uploader.onWhenAddingFileFailed = () => {
      this.fileTypeError = true;
    };

    this.uploader.onAfterAddingFile = () => {
      this.fileTypeError = false;
    };
  }

  close() {
    this.windowRef.close();
  }

  onSubmit() {
    this.submitted = true;
    this.specificationService.importFile(this.inputForm.value).pipe(
      tap((response: ApiResponse<CartProduct[]>) => this.handleResponse(response)),
      takeUntil(this.unsubscribe),
    ).subscribe();
  }

  onChange($event: Event) {
    if (this.uploader.queue.length > 1) {
      this.uploader.removeFromQueue(this.uploader.queue[0]);
    }

    this.file = this.uploader.queue[0]._file;

    if (this.uploader.queue.length) {
      this.file = this.uploader.queue[0]._file;
      this.fileName = this.file.name;
      this.fileSize = this.file.size / 1024 / 1024;
      this.fileType = this.file.type;
    }

    this.inputForm.controls.file.patchValue(this.file);
  }

  private handleResponse(response: ApiResponse<CartProduct[]>) {
    if (!response.success) {
      this.showFail = true;
    }
    this.submitted = false;
    this.reset();
    this.onFoundProducts.next(response.data);
    this.close();
  }

  private reset(): void {
    this.inputForm.reset();
    this.uploader.clearQueue();
    this.fileName = translations.chooseTheFile;
    this.fileSize = 0;
    this.fileType = '';
    this.cdr.detectChanges();
  }
}
